/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ChromeEventRescheduleWrapperQueryVariables = {};
export type ChromeEventRescheduleWrapperQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ChromeEventRescheduleWrapper_viewer">;
    };
};
export type ChromeEventRescheduleWrapperQuery = {
    readonly response: ChromeEventRescheduleWrapperQueryResponse;
    readonly variables: ChromeEventRescheduleWrapperQueryVariables;
};



/*
query ChromeEventRescheduleWrapperQuery {
  viewer {
    ...ChromeEventRescheduleWrapper_viewer
    id
  }
}

fragment ChromeEventRescheduleWrapper_viewer on Viewer {
  user {
    id
    orgs(first: 1000000) {
      edges {
        node {
          id
          experiments
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "ChromeEventRescheduleWrapperQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ChromeEventRescheduleWrapper_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ChromeEventRescheduleWrapperQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        },
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "d731406f8964fa71c0632c0bed65c13b",
            "id": null,
            "metadata": {},
            "name": "ChromeEventRescheduleWrapperQuery",
            "operationKind": "query",
            "text": "query ChromeEventRescheduleWrapperQuery {\n  viewer {\n    ...ChromeEventRescheduleWrapper_viewer\n    id\n  }\n}\n\nfragment ChromeEventRescheduleWrapper_viewer on Viewer {\n  user {\n    id\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          experiments\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '80fa2b35fe9069fb497b9547450efd3f';
export default node;
